/**
 * Judge.me AI summary ("Customers say"), fr.loccitane.com format.
 *
 * Judge.me renders the summary (.jm-ai-insights) after the "Write a review"
 * button. To show it right under the widget title without breaking the reading
 * order (WCAG 1.3.2), the summary is rendered again right after the title, in
 * DOM order: hidden heading, AI caption, summary text. The Judge.me original is
 * hidden but left in place: the widget is a Vue app and moving its nodes could
 * break its re-renders.
 *
 * If the summary holds interactive content (review highlights / keywords
 * enabled in Judge.me), the original is left untouched.
 * Styles: judgeme-custom.css, section 7.
 */
(function judgeMeAiSummary() {
  'use strict';

  var widget = document.getElementById('judgeme_product_reviews');
  if (!widget) return;

  var CARD_CLASS = 'lo-ai-summary';
  var TITLE_ID = 'lo-ai-summary-title';

  function text(element) {
    return element ? element.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function readSummary(original) {
    if (original.querySelector('a, button, input, select, textarea, [tabindex]')) return null;

    var paragraphs = original.querySelectorAll('p.jm-text');
    var body = null;
    for (var i = 0; i < paragraphs.length; i++) {
      if (!paragraphs[i].closest('.jm-ai-insights__header, .jm-ai-disclaimer')) {
        body = paragraphs[i];
        break;
      }
    }
    if (!text(body)) return null;

    return {
      title: text(original.querySelector('.jm-ai-insights__header > .jm-text')),
      caption: text(original.querySelector('.jm-ai-disclaimer .jm-text')),
      body: text(body)
    };
  }

  function createCard() {
    var card = document.createElement('section');
    card.className = CARD_CLASS;
    card.setAttribute('aria-labelledby', TITLE_ID);
    card.innerHTML =
      '<h3 class="' + CARD_CLASS + '__title" id="' + TITLE_ID + '"></h3>' +
      '<p class="' + CARD_CLASS + '__caption"></p>' +
      '<p class="' + CARD_CLASS + '__text"></p>';
    return card;
  }

  function setText(element, value) {
    if (element.textContent !== value) element.textContent = value;
    if (element.hidden !== !value) element.hidden = !value;
  }

  function process() {
    var original = widget.querySelector('.jm-review-widget-minimal-header > .jm-ai-insights');
    var title = widget.querySelector('.jm-review-widget-minimal-header__title');
    var card = widget.querySelector('.' + CARD_CLASS);
    var summary = original && title ? readSummary(original) : null;

    if (!summary) {
      if (card) card.remove();
      if (original && original.hidden) original.hidden = false;
      return;
    }

    if (!card) card = createCard();
    // Fallback heading when the Judge.me title setting is empty
    setText(card.querySelector('.' + CARD_CLASS + '__title'), summary.title || 'Customer review summary');
    setText(card.querySelector('.' + CARD_CLASS + '__caption'), summary.caption);
    setText(card.querySelector('.' + CARD_CLASS + '__text'), summary.body);

    if (title.nextElementSibling !== card) title.insertAdjacentElement('afterend', card);
    if (!original.hidden) original.hidden = true;
  }

  // Judge.me renders the widget client-side and re-renders it on tab, filter
  // and sort changes. process() only writes when something differs, so its own
  // mutations settle after one pass.
  new MutationObserver(process).observe(widget, { childList: true, subtree: true });
  process();
})();
